<template>
  <div>
    <el-dialog
      title="Update Risk Status"
      :visible.sync="dialogEditRiskStatus"
      width="417px"
      center
    >
    <div v-loading="loading">
      <el-form
        :model="formData"
        id="riskForm"
        ref="riskForm"
        label-width="150px"
        size="small"
        :rules="riskFormRules"
        label-position="left"
      >
        <el-form-item label="Risk Fee">
          <el-switch
            v-model="formData.riskfeeoption"
            active-text="Yes"
            inactive-text="No"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>

        <el-form-item label="Currency" prop="currency">
          <el-select
            v-model="formData.complianceChargeCurrency"
            placeholder="Please select currency"
            :loading="loadingCurrency"
            
          >
            <el-option
              v-for="item in currencies"
              :key="item.uid"
              :label="`${item.currency.toUpperCase()}`"
              :value="`${item.currency.toUpperCase()}`"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditRiskStatus = false">Cancel</el-button>
        <el-button type="primary" @click="submitRiskStatus()" :loading="submitting"
          >Confirm</el-button
        >
      </span>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRiskFeeOption, updateRiskFeeOption } from "@/api/customer";
import { getCurrencyActive } from "@/api/currency";
export default {
  name: "CustomerRiskUpdate",
  data() {
    return {
      customer_uid: "",
      project_uid: "",
      dialogEditRiskStatus: false,
      submitting: false,
      loading: false,
      loadingCurrency: false,
      formData: {
        riskfeeoption: false,
        complianceChargeCurrency: "",
      },
      riskFormRules: {
        complianceChargeCurrency: [
          {
            required: true,
            message: "Please select currency",
            trigger: "blur",
          },
        ],
      },
      currencies: [],
    };
  },
  methods: {
    show(customer_uid, project_uid) {
      this.customer_uid = customer_uid;
      this.project_uid = project_uid;

      this.getStatus();
      this.getCurrency();

      this.dialogEditRiskStatus = true;
    },
    getCurrency() {
      this.loadingCurrency = true
      getCurrencyActive(this.project_uid).then(({ result, data }) => {
        this.loadingCurrency = false
        if (result) {
          this.currencies = data;
        }
      });
    },
    getStatus() {
      this.loading = true;
      getRiskFeeOption(this.customer_uid).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.formData.riskfeeoption = data.riskfeeoption;
          this.formData.complianceChargeCurrency = data.complianceChargeCurrency;
        }
      });
    },
    submitRiskStatus() {
      this.$refs.riskForm.validate((valid) => {
        if (valid) {
          this.submitting = true;
          updateRiskFeeOption(this.customer_uid, this.formData).then(
            ({ result, message }) => {
              this.submitting = false
              if (result) {
                this.dialogEditRiskStatus = false;
                this.$emit("submited", this.formData);
              }
              this.$notify({
                title: result ? "Success" : "Error",
                message: message,
                type: result ? "success" : "error",
                duration: 2000,
              });
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
